import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ToastProvider, ToastViewport } from "ui-components/toast";
import { env } from "@/config/env";
import * as Sentry from "@sentry/react";
import { ErrorPage } from "./error-page";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5 // 5 minutes
    }
  }
});

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const enableGoogleAnalytics = env.ENABLE_GOOGLE_ANALYTICS;
  const environmentName = env.ENVIRONMENT_NAME;

  return (
    <Sentry.ErrorBoundary fallback={ErrorPage} showDialog>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <ToastProvider>
            <Helmet>
              {enableGoogleAnalytics && (
                <>
                  <script async src="https://www.googletagmanager.com/gtag/js?id=G-TX6SVQH7WX"></script>
                  <script>
                    {`
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                  dataLayer.push(arguments);
                }
                gtag("js", new Date());
                gtag("config", "G-TX6SVQH7WX");
                `}
                  </script>
                </>
              )}
              <title>MavenAI{environmentName != "production" ? ` | ${environmentName}` : ""}</title>
            </Helmet>
            {children}
            <ToastViewport className="fixed bottom-6 left-6" />
          </ToastProvider>
        </HelmetProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
};
